import PropTypes from "prop-types";
import { CircularProgress, Alert, AlertTitle, Box } from "@mui/material";
import ErrorBox from "./ErrorBox";

BackendFeedback.propTypes = {
  backendCall: PropTypes.shape({
    feedback: PropTypes.string.isRequired,
  }).isRequired,
  translateError: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  height: PropTypes.number,
};

function BackendFeedback({ backendCall, children, height, translateError, silentPending }) {
  let child;
  if (backendCall.feedback === "pending" && !silentPending) {
    child = (
      <Box sx={{ height }}>
        <CircularProgress />
      </Box>
    );
  } else if (backendCall.feedback === "error") {
    child = (
      <ErrorBox userError={translateError && translateError(backendCall.response)} error={backendCall.response} />
    );
  } else if (backendCall.feedback === "ready" || (backendCall.feedback === "pending" && silentPending)) {
    // FIXME this component does not correctly defer loading children, only when
    // the children(backendCall) supply its own logic
    child = typeof children === "function" ? children(backendCall) : children;
  } else if (backendCall.feedback === "silent") {
    child = null;
  } else {
    child = (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        Invalid implementation of backend feedback, please contact administrator.
        <br />
        {"Feedback: " + backendCall.feedback}
      </Alert>
    );
  }

  return child;
}

export default BackendFeedback;
